var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormsRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14006 0.999961L2.13843 14.999C2.13837 15.5488 2.58822 15.9988 3.13807 15.9989L12.8601 16C13.4101 16.0001 13.8602 15.5501 13.8603 15L13.8616 3.68398C13.8616 3.37695 13.7397 3.08248 13.5226 2.86537L10.9978 0.33996C10.7807 0.122846 10.4863 0.000847006 10.1793 0.000815635L3.14024 6.56021e-09C2.59019 -6.27341e-05 2.14012 0.449913 2.14006 0.999961Z",
    fill: "url(#paint0_linear_209_2855)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96495 10.717H11.1965C11.3558 10.717 11.4849 10.5878 11.4849 10.4285V9.72501C11.4849 9.56568 11.3558 9.43652 11.1965 9.43652H6.96495C6.80562 9.43652 6.67647 9.56568 6.67647 9.72501V10.4285C6.67647 10.5878 6.80562 10.717 6.96495 10.717Z",
    fill: "#EBEFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96495 7.71892H11.1965C11.3558 7.71892 11.4849 7.58977 11.4849 7.43044V6.72696C11.4849 6.56763 11.3558 6.43848 11.1965 6.43848H6.96495C6.80562 6.43848 6.67647 6.56763 6.67647 6.72696V7.43044C6.67647 7.58977 6.80562 7.71892 6.96495 7.71892Z",
    fill: "#EBEFF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96495 13.7153H11.1965C11.3558 13.7153 11.4849 13.5861 11.4849 13.4268V12.7233C11.4849 12.564 11.3558 12.4348 11.1965 12.4348H6.96495C6.80562 12.4348 6.67647 12.564 6.67647 12.7233V13.4268C6.67647 13.5861 6.80562 13.7153 6.96495 13.7153Z",
    fill: "#EBEFF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16385 7.72708C5.52191 7.72708 5.81218 7.43681 5.81218 7.07875C5.81218 6.72069 5.52191 6.43042 5.16385 6.43042C4.80579 6.43042 4.51552 6.72069 4.51552 7.07875C4.51552 7.43681 4.80579 7.72708 5.16385 7.72708Z",
    fill: "#EBEFF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16385 10.7251C5.52191 10.7251 5.81218 10.4349 5.81218 10.0768C5.81218 9.71873 5.52191 9.42847 5.16385 9.42847C4.80579 9.42847 4.51552 9.71873 4.51552 10.0768C4.51552 10.4349 4.80579 10.7251 5.16385 10.7251Z",
    fill: "#EBEFF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16385 13.7234C5.52191 13.7234 5.81218 13.4332 5.81218 13.0751C5.81218 12.717 5.52191 12.4268 5.16385 12.4268C4.80579 12.4268 4.51552 12.717 4.51552 13.0751C4.51552 13.4332 4.80579 13.7234 5.16385 13.7234Z",
    fill: "#EBEFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9969 0.339672C10.8482 0.190977 10.6632 0.0869528 10.4627 0.0361328V3.2962L13.8611 6.69455V3.68331C13.8611 3.37629 13.7391 3.08185 13.522 2.86473L10.9969 0.339672Z",
    fill: "url(#paint1_linear_209_2855)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8268 3.40247C13.8305 3.41856 13.8339 3.43418 13.837 3.44927H10.7738C10.5569 3.44927 10.381 3.27344 10.381 3.05651V0.0187988C10.4049 0.0230652 10.4301 0.0280531 10.456 0.0337938C10.6844 0.0843001 10.8926 0.201719 11.058 0.367072L13.494 2.80314C13.6588 2.96786 13.7744 3.1755 13.8268 3.40247Z",
    fill: "url(#paint2_linear_209_2855)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8611 14.0293V14.9992C13.8611 15.5493 13.411 15.9993 12.861 15.9993H3.13901C2.58912 15.9993 2.13924 15.5494 2.13924 14.9996V14.0293H13.8611Z",
    fill: "url(#paint3_linear_209_2855)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_2855",
    x1: -0.47516,
    y1: 0.832474,
    x2: 10.6709,
    y2: 11.9785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7049BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_2855",
    x1: 12.8659,
    y1: 5.45053,
    x2: 11.6581,
    y2: 1.92136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5531AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5531AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_2855",
    x1: 10.7693,
    y1: 1.84289,
    x2: 12.1722,
    y2: 3.24583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7049BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_209_2855",
    x1: 8.00016,
    y1: 14.5469,
    x2: 8.00016,
    y2: 16.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5531AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5531AA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsRequests);
export default __webpack_public_path__ + "static/media/FormsRequests.20a9152f1fbe990a2d69a80c15ac9d4e.svg";
export { ForwardRef as ReactComponent };